import React from 'react';
import Preloader from "../../../utils/preloader";
import {Plural} from "../../../utils/utils";

class RequirementsModal extends React.Component {
    constructor (props) {
        super();

        const meta = props.courseMeta;
        const data = meta['requirements'] ? meta['requirements'] : '';

        this.state = {
            loading: false,
            data: data,
            valid: false
        }
    }

    validate = () => {
        const t = this;
        const {data} = t.state;
        t.setState({
            valid: !!data.length
        })
    };

    handleChange = (e) => {
        const t = this;
        t.setState({data: e.target.value}, t.validate);
    };

    handleSave = () => {
        const t = this;
        const p = t.props;

        const {data} = t.state;
        const d = {'requirements': data};

        t.setState({loading: true});
        p.onSave(d, (r) => {
            t.setState({loading: false});
        });
    };

    render() {
        const t = this;
        const {data, loading} = t.state;
        const p = t.props;

        const preloader = loading ? <Preloader/> : '';

        const maxLength = 300;
        const remainingSymbols = maxLength - data.length;

        return (
            <div className="course_edit_modal">
                <div className="cem_inner">
                    <div className="cem_text">
                        <h3>Блок "Вам понадобится"</h3>
                        <p className="block_description">Опишите, что понадобится студенту для прохождения курса. Например, "<i>Коврик-пенка, гимнастический шар, 2 пудовые гири</i>"</p>
                    </div>
                    <div className="cem_content cem_text">
                        <h5>Вам понадобится</h5>
                        <textarea maxLength={maxLength} placeholder="программы Adobe Photoshop, Adobe Lightroom" onChange={t.handleChange} value={data}/>
                        <div className="cem_hint">осталось {remainingSymbols} символ{Plural(remainingSymbols, '', 'а', 'ов')}</div>
                    </div>
                    <div className="cem_buttons">
                        <button className="small" onClick={p.onModalClose}>отмена</button>
                        <button className="small" onClick={t.handleSave}>сохранить</button>
                    </div>
                </div>

                {preloader}
            </div>
        );
    }
}

export default RequirementsModal;
